import { BaseModel } from "../base.model";

export class WorkflowGraphConnection extends BaseModel{         
    SourceId: string
    TargetId: string    
    
    constructor(sourceId: string, targetId: string, id: number, version: string){
        super();
        this.Id = id;
        this.Version = version;
        this.SourceId = sourceId;
        this.TargetId = targetId;
    }

}



